import { useTranslation } from "react-i18next";

import styles from "./styles.module.scss";

const App = (props) => {
  const { t } = useTranslation();

  // Bug real (auditoría 2026-08-16): a diferencia de toda celda hermana
  // (Numeric, Checkbox, DateInput, ...) este input no tenía onChange (ni
  // siquiera se desestructuraba de props) y nunca ramificaba por
  // props.editable — se veía editable/enfocable pero cualquier texto
  // tipeado se descartaba en el siguiente render (y React logueaba el
  // warning de controlled input sin onChange). El tipo "references" está
  // deshabilitado como opción al crear un campo (Field.js lo marca
  // disabled con label "(beta)"), así que todavía no existe un contrato de
  // onChange real que cablear acá — el fix mínimo y seguro es dejarlo
  // explícitamente no interactivo (disabled) en vez de simular una edición
  // que nunca persiste.
  return props.editable ? (
    <input
      type="text"
      value={props.value || ""}
      disabled
      className={`${styles.input} form-control rounded-0 border-0`}
    />
  ) : (
    <div className="p-2">{props.value}</div>
  );
};

export default App;
